// @ts-ignore
import { createRequestActionNames } from 'helpers'

export const ADMIN_WELCOME_EMAIL = createRequestActionNames('ADMIN_WELCOME_EMAIL', ['GET', 'POST', 'PUT'])
export const ADMIN_WELCOME_EMAIL_UPLOAD_IMAGE_REQUEST = 'ADMIN_WELCOME_EMAIL/UPLOAD_IMAGE_REQUEST'
